import { FilterIdentifier } from 'models/saved_view'
import { queryClient } from './queryClient'

/**
 * Invalidate every saved-filter cache: the per-table dropdown list and the
 * settings-page table. Query keys are owned by `useGetSavedFiltersOptions` /
 * `useGetAllSavedFilters` in `services/api.ts`; call this after any mutation
 * that creates, updates, or deletes a SavedView (manual save/edit modals,
 * the push-to-campaign auto-save, ...).
 */
export async function invalidateSavedFilterQueries(
  identifier: FilterIdentifier
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ['saved_filters', identifier] }),
    queryClient.invalidateQueries({ queryKey: ['saved-views/'] }),
  ])
}
